const API_URL = process.env.REACT_APP_API_URL || 'https://sante.secury.ovh/api';

export default API_URL;
